import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "catalog" };
const _hoisted_2 = { class: "catalog__categories" };
const _hoisted_3 = { class: "catalog__bulk-search-instructions" };
const _hoisted_4 = { class: "catalog__products" };
import CatalogProductsBulkSearch from "../components/CatalogProductsBulkSearch.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogBulkSearchView',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('catalog.bulk_search.instructions')), 1)
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(CatalogProductsBulkSearch, { "category-code": null })
                ])
            ]));
        };
    }
});
